/* eslint-disable camelcase */
import { Base64 } from "js-base64"
import { base64Decode } from "@/utils/utils"
// 设置omnichat user
export const setOmnichat = function () {
  if (!document.getElementById("omnichatUser")) {
    const accountInfo = localStorage.getItem("accountInfo") ? base64Decode(localStorage.getItem("accountInfo")) : {}
    const script = document.createElement("script")
    // const phone =
    //   accountInfo.areaCode && accountInfo.phone
    //     ? Base64.encode(JSON.stringify(accountInfo.areaCode + " " + accountInfo?.phone))
    //     : ""
    const id = accountInfo.custId ? Base64.encode(JSON.stringify(accountInfo.custId)) : ""
    const name = accountInfo.userName ? Base64.encode(JSON.stringify(accountInfo.userName)) : ""
    script.id = "omnichatUser"
    // todo MPJ 区分omnichat
    script.innerHTML = `
      // OMNICHAT TRACKER V1.0
      window.omnichatTracker = window.omnichatTracker || [];
      window.omnichatTracker.push(['init', 'config', {
          "memberId": "${id}",
          "memberEmail": "",
          "memberName": "${name}",
          "memberProfilePic": ""
      }]);
    `
    // console.log("decode memberId", id, "====>", Base64.decode(id))
    // console.log("decode memberPhone", phone, "====>", Base64.decode(phone))
    // console.log("decode memberName", name, "====>", Base64.decode(name))
    document.body.appendChild(script)
  }
}

// omnichat 要追蹤查看商品頁的次數，請發送以下 view_product 的事件
export const omnichatViewProduct = params => {
  if (window.omnichatTracker) {
    window.omnichatTracker.push(["event", "view_product", params])
    console.log("omnichatViewProduct", window.omnichatTracker)
  }
}

// omnichat 要追蹤加入購物車的行為，請發送以下 add_to_cart 的事件:
export const omnichatAddToCart = params => {
  if (window.omnichatTracker) {
    window.omnichatTracker.push([
      "event",
      "add_to_cart",
      {
        items: params
        // [{
        //   id: "P12345",
        //   name: "A Black T-Shirt",
        //   brand: "Brand B",
        //   category: "Apparel/T-Shirts",
        //   variant: "Black",
        //   quantity: 1,
        //   price: "2.0"
        // }]
      }
    ])
    console.log("omnichatAddToCart", window.omnichatTracker)
  }
}

// omnichat 要追蹤從購物車移除商品的行為，請發送以下 remove_from_cart 的事件:
export const omnichatRemoveFromCart = params => {
  if (window.omnichatTracker) {
    window.omnichatTracker.push([
      "event",
      "remove_from_cart",
      {
        items: params
        // [{
        //   id: "P12345",
        //   name: "A Black T-Shirt",
        //   brand: "Brand B",
        //   category: "Apparel/T-Shirts",
        //   variant: "Black",
        //   quantity: 1,
        //   price: "2.0"
        // }]
      }
    ])
    console.log("omnichatRemoveFromCart", window.omnichatTracker)
  }
}

// omnichat 要追蹤結帳情況的行為，請發送以下 checkout 的事件:
export const omnichatCheckout = params => {
  if (window.omnichatTracker) {
    window.omnichatTracker.push([
      "event",
      "checkout",
      {
        items: params
      }
    ])
  }
}

// omnichat 要追蹤購買完成的行為，請發送以下 purchase 的事件:
export const omnichatPurchase = (params, transaction_id, amount) => {
  if (window.omnichatTracker) {
    window.omnichatTracker.push([
      "event",
      "purchase",
      {
        transaction_id,
        amount,
        currency: "",
        items: params
      }
    ])
  }
}

export const handleChangeCartNumberOmnichat = (currentNumber, oldNumber, item) => {
  try {
    if (currentNumber > oldNumber) {
      omnichatAddToCart([{ ...item, quantity: currentNumber - oldNumber }])
    } else {
      omnichatRemoveFromCart([{ ...item, quantity: oldNumber - currentNumber }])
    }
  } catch (error) {
    console.error(error)
  }
}
